<template>
<div class="chapter">
<div class="inner_page">
<div id="Stranded_eBook-1.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="EB" id="toc_marker-2"><span class="char-style-override-1">ST</span><span class="char-style-override-1">R</span><span class="char-style-override-1">ANDED</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-2">Val McDermid</span></p>
<p class="BT1stPara para-style-override-2"><span class="char-style-override-3">Foreword by Ian Rankin</span></p>
<p class="BT1stPara para-style-override-3"><img alt="V-1.tif" class="image" height="24" src="images/V-1_fmt.png" width="27"/></p>
<p class="BT1stPara para-style-override-1">Grove Press</p>
<p class="BT1stPara para-style-override-1">New York</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Stranded_eBook1.vue?3a8ef676